// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R3Q1r_pZDd4aHaUAhLI8{color:var(--content-primary-primary);letter-spacing:.13923px;text-align:left;vertical-align:inherit;border:none;padding:0;font-size:13px;font-weight:400;line-height:1.43}.wqzFoo1f2ksWCVhZW6d0{color:var(--content-primary-tertiary);font-weight:500;line-height:24px}.tkLEISdWHpAklvxcF7U1{white-space:nowrap;text-overflow:ellipsis;align-content:center;min-height:40px;padding:0 8px;overflow:hidden}._9eNdhNucegHsjH_otSz{overflow:initial}.x4b9nlzBf2chgqdeJo6m{width:100%;height:100%;color:unset;text-decoration:none;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `R3Q1r_pZDd4aHaUAhLI8`,
	"cellHeader": `wqzFoo1f2ksWCVhZW6d0`,
	"tableCell": `tkLEISdWHpAklvxcF7U1`,
	"overflowInitial": `_9eNdhNucegHsjH_otSz`,
	"link": `x4b9nlzBf2chgqdeJo6m`
};
export default ___CSS_LOADER_EXPORT___;
